




























































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import FieldSectionSettingModal from '@/app/components/MasterField/FieldSectionSettingModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* api */
import GroupListApi from '@/app/model/api/groupListApi'
import DistrictListApi from '@/app/model/api/districtListApi'
import MasterFieldDetailApi from '@/app/model/api/masterFieldDetailApi'
import MasterFieldCreateApi from '@/app/model/api/masterFieldCreateApi'
import MasterFieldEditApi from '@/app/model/api/masterFieldEditApi'
import MasterFieldDeleteApi from '@/app/model/api/masterFieldDeleteApi'
/* module */
import SelectClass from '@/app/module/select'
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import { Chrome } from 'vue-color'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Loading,
    Error409Modal,
    ChromePicker: Chrome,
    FieldSectionSettingModal,
    ErrorInfo,
    ConfirmModal
  }
})
export default class GroupCreate extends Vue {
  private basicData: {[key:string]: string|any} = {
    position: {
      lat: 36.00000,
      lng: 138.00000
    },
    zoom: 3,
    mapType: 'satellite'
  }
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private colors: any = '#FF3535'
  private groupData: any = {}
  private districtData: any = {}
  private tempSourceList: {text: string, value: number}[] = SelectClass.tempSourceList
  private rainfallSourceList: {text: string, value: number}[] = SelectClass.rainfallSourceList
  // private beforeEditImgSensorType: number = 0
  private selectedFcSensor1: number|null = null
  private selectedFcSensor2: number|null = null
  private selectedFsSensor: number|null = null
  private selectedPwSensor: number|null = null
  private fieldData: any = {
    field: {
      field_name: '',
      group_id: '',
      district_id: '',
      temp_source: 1,
      rainfall_source: 1,
      color_code: '#FF3535',
      field_point_lat: null,
      field_point_lng: null,
      field_area_m2: null,
      field_area: null,
      remarks: ''
    },
    fs_sensor: [
      {
        sensor_id: 0,
        sensor_key: 0,
        sensor_model_number: '',
        sensor_point_name: '',
        sensor_point_lat: 0,
        sensor_point_lng: 0,
        is_main: 0
      }
    ],
    pw_sensor: [
      {
        sensor_id: 0,
        sensor_key: 0,
        sensor_model_number: '',
        sensor_point_name: '',
        sensor_point_lat: 0,
        sensor_point_lng: 0,
        is_main: 0
      }
    ],
    fc_sensor: [
      {
        sensor_id: 0,
        sensor_key: 0,
        sensor_model_number: '',
        sensor_point_name: '',
        sensor_point_lat: 0,
        sensor_point_lng: 0,
        is_main: 0
      }
    ],
    field_polygon: []
  }
  /* 表示非表示 */
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showColorPicker: boolean = false
  private showFieldSectionSetting: boolean = false
  private isEdit: boolean = false
  private showLoading: boolean = true
  private showFsSensor: boolean = false
  private showPwSensor: boolean = false
  private showImgSensorType: boolean = false
  private showFcSensor: boolean = false
  private showError409Modal: boolean = false
  private showSensorChangeModal: boolean = false
  private show400ErrorMessage: boolean = false

  created () {
    this.getGroupList()
    this.getDistrictList()

    if (this.$route.path === '/master/field/create') {
      this.isEdit = false
      this.showLoading = false
      this.colors = this.fieldData.field.color_code
    } else {
      this.isEdit = true
      this.showImgSensorType = true
      this.getMasterFieldList()
    }
  }

  private getGroupList () {
    (async () => {
      const data: any = {
        order_name: 'group_name',
        sort: 'asc',
        text: ''
      }

      const result = await GroupListApi.getGroupList(data)
      if (result.isOk()) {
        this.groupData = result.getPayload().groups
        if (result.getPayload().total_group === 0) {
          this.alertTitle = 'グループが未登録です。グループを登録してから圃場を追加してください。'
          this.alertText = ''
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private getDistrictList () {
    (async () => {
      const data : any = {
        sortName: 'district_name',
        sort: 'asc',
        text: ''
      }

      const result = await DistrictListApi.getDistrictList(data)
      if (result.isOk()) {
        this.districtData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertTitle = '地区が未登録です。地区を登録してから圃場を追加してください。'
          this.alertText = ''
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  // センサー選択解除
  private doReleaseSensor (key: string, sensorId: number) {
    if (key === 'fc_sensor1') {
      for (let i in this.fieldData.fc_sensor) {
        if (this.fieldData.fc_sensor[i].sensor_id === sensorId) {
          this.fieldData.fc_sensor[i].display_number = null
          this.selectedFcSensor1 = null
        }
      }
    } else if (key === 'fc_sensor2') {
      for (let i in this.fieldData.fc_sensor) {
        if (this.fieldData.fc_sensor[i].sensor_id === sensorId) {
          this.fieldData.fc_sensor[i].display_number = null
          this.selectedFcSensor2 = null
        }
      }
    } else if (key === 'fs_sensor') {
      for (let i in this.fieldData.fs_sensor) {
        if (this.fieldData.fs_sensor[i].sensor_id === sensorId) {
          this.fieldData.fs_sensor[i].is_main = 0
          this.selectedFsSensor = null
        }
      }
    } else {
      for (let i in this.fieldData.pw_sensor) {
        if (this.fieldData.pw_sensor[i].sensor_id === sensorId) {
          this.fieldData.pw_sensor[i].is_main = 0
          this.selectedPwSensor = null
        }
      }
    }
  }

  // センサー選択
  private doSelectSensor (key: string, sensorId: number) {
    if (key === 'fc_sensor1') {
      for (let i in this.fieldData.fc_sensor) {
        if (this.fieldData.fc_sensor[i].sensor_id === sensorId) {
          this.fieldData.fc_sensor[i].display_number = 1
          this.selectedFcSensor1 = sensorId
        } else if (this.fieldData.fc_sensor[i].display_number !== 2) {
          this.fieldData.fc_sensor[i].display_number = null
        }
      }
    } else if (key === 'fc_sensor2') {
      for (let i in this.fieldData.fc_sensor) {
        if (this.fieldData.fc_sensor[i].sensor_id === sensorId) {
          this.fieldData.fc_sensor[i].display_number = 2
          this.selectedFcSensor2 = sensorId
        } else if (this.fieldData.fc_sensor[i].display_number !== 1) {
          this.fieldData.fc_sensor[i].display_number = null
        }
      }
    } else if (key === 'fs_sensor') {
      for (let i in this.fieldData.fs_sensor) {
        if (this.fieldData.fs_sensor[i].sensor_id === sensorId) {
          this.fieldData.fs_sensor[i].is_main = 1
          this.selectedFsSensor = this.fieldData.fs_sensor[i].sensor_id
        } else {
          this.fieldData.fs_sensor[i].is_main = 0
        }
      }
    } else {
      for (let i in this.fieldData.pw_sensor) {
        if (this.fieldData.pw_sensor[i].sensor_id === sensorId) {
          this.fieldData.pw_sensor[i].is_main = 1
          this.selectedPwSensor = this.fieldData.pw_sensor[i].sensor_id
        } else {
          this.fieldData.pw_sensor[i].is_main = 0
        }
      }
    }
  }

  private getMasterFieldList () {
    (async () => {
      const result = await MasterFieldDetailApi.getMasterFieldDetail(this.$route.params.field_id)
      if (result.isOk()) {
        this.fieldData = result.getPayload()
        // カラーコードセット
        if (this.fieldData.field.color_code === '') {
          this.colors = '#FF3535'
        } else {
          this.colors = this.fieldData.field.color_code
        }
        // センサー系表示切替
        if (this.fieldData.fs_sensor.length !== 0) {
          this.showFsSensor = true
          for (let i in this.fieldData.fs_sensor) {
            if (this.fieldData.fs_sensor[i].is_main === 1) {
              this.selectedFsSensor = this.fieldData.fs_sensor[i].sensor_id
            }
          }
        }
        if (this.fieldData.pw_sensor.length !== 0) {
          this.showPwSensor = true
          for (let i in this.fieldData.pw_sensor) {
            if (this.fieldData.pw_sensor[i].is_main === 1) {
              this.selectedPwSensor = this.fieldData.pw_sensor[i].sensor_id
            }
          }
        }
        if (this.fieldData.fc_sensor.length !== 0) {
          this.showFcSensor = true
          for (let i in this.fieldData.fc_sensor) {
            if (this.fieldData.fc_sensor[i].display_number === 1) {
              this.selectedFcSensor1 = this.fieldData.fc_sensor[i].sensor_id
            } else if (this.fieldData.fc_sensor[i].display_number === 2) {
              this.selectedFcSensor2 = this.fieldData.fc_sensor[i].sensor_id
            }
          }
        }
        // マップ
        if (this.fieldData.field_polygon.length !== 0) {
          this.basicData.zoom = 16
          this.basicData.position = { lat: this.fieldData.field.field_point_lat, lng: this.fieldData.field.field_point_lng }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private roundingLatLng (num: number) {
    return Math.round(num * 1000000) / 1000000
  }

  private flooringLatLng (num: number) {
    return Math.floor(num * 1000000) / 1000000
  }

  private doSetPolygonData (data: any) {
    this.showFieldSectionSetting = false
    this.fieldData.field.field_area_m2 = Math.floor(data.area)
    if (data.centerPath.lat !== null) {
      this.fieldData.field.field_point_lat = this.roundingLatLng(data.centerPath.lat)
    } else {
      this.fieldData.field.field_point_lat = null
    }
    if (data.centerPath.lng !== null) {
      this.fieldData.field.field_point_lng = this.roundingLatLng(data.centerPath.lng)
    } else {
      this.fieldData.field.field_point_lng = null
    }
    this.fieldData.field_polygon = data.polygonPath
    this.calculationArea()
    if (data.centerPath.lat === null) {
      this.basicData.position = {
        lat: 36.00000,
        lng: 138.00000
      }
      this.basicData.zoom = 3
    } else {
      this.basicData.position = {
        lat: this.fieldData.field.field_point_lat,
        lng: this.fieldData.field.field_point_lng
      }
      this.basicData.zoom = 16
    }
  }

  private colorSettingOk () {
    this.showColorPicker = false
  }

  // 作付け登録
  private async masterFieldCreate () {
    const body = {
      field: this.fieldData.field,
      field_polygon: this.fieldData.field_polygon
    }
    const result = await MasterFieldCreateApi.doMasterFieldCreate(body)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '圃場登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/field').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async masterFieldEdit () {
    const body = {
      field: this.fieldData.field,
      field_polygon: this.fieldData.field_polygon,
      fs_sensor: this.fieldData.fs_sensor,
      pw_sensor: this.fieldData.pw_sensor,
      fc_sensor: this.fieldData.fc_sensor
    }

    const result = await MasterFieldEditApi.doMasterFieldEdit(this.$route.params.field_id, body)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '圃場編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/field').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private isValidate () {
    // リセット
    this.errorMessages = {}

    const fieldNameFlag = Validator.validateInputFieldName('fieldNameErrorMessage', this.fieldData.field.field_name)
    const groupNameFlag = Validator.validateInputGroupName('groupNameErrorMessage', this.fieldData.field.group_id)
    const districtNameFlag = Validator.validateInputDistrictName('districtNameErrorMessage', this.fieldData.field.district_id)
    const fieldColorFlag = Validator.validateInputFieldColor('fieldColorErrorMessage', this.fieldData.field.color_code)
    const fieldAreaM2Flag = Validator.validateInputFieldArea('fieldAreaM2ErrorMessage', this.fieldData.field.field_area_m2)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())
    let isError = true

    if (this.fieldData.field.field_point_lat !== null) {
      let decimalPointLength = String(this.fieldData.field.field_point_lat).split('.')
      if (this.fieldData.field.field_point_lat < -90 || this.fieldData.field.field_point_lat > 90) {
        this.$set(this.errorMessages, 'latlngErrorMessage', '緯度は-90以上90以下の範囲で入力してください。')
        isError = false
      } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 6) {
        this.$set(this.errorMessages, 'latlngErrorMessage', '緯度/経度は小数点第6位までの範囲で入力してください。')
        isError = false
      }
    } else {
      this.$set(this.errorMessages, 'latlngErrorMessage', '緯度/経度は必ず入力してください。')
      isError = false
    }
    if (this.fieldData.field.field_point_lng !== null) {
      let decimalPointLength = String(this.fieldData.field.field_point_lng).split('.')
      if (this.fieldData.field.field_point_lng < -180 || this.fieldData.field.field_point_lng > 180) {
        this.$set(this.errorMessages, 'latlngErrorMessage', '経度は-180以上180以下の範囲で入力してください。')
        isError = false
      } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 6) {
        this.$set(this.errorMessages, 'latlngErrorMessage', '緯度/経度は小数点第6位までの範囲で入力してください。')
        isError = false
      }
    } else {
      this.$set(this.errorMessages, 'latlngErrorMessage', '緯度/経度は必ず入力してください。')
      isError = false
    }

    if (this.fieldData.field.field_area > 10000) {
      this.$set(this.errorMessages, 'fieldAreaErrorMessage', '圃場面積(ha)は0以上10,000以下の範囲ではありません。')
      isError = false
    }

    return fieldNameFlag && groupNameFlag && districtNameFlag && fieldColorFlag && fieldAreaM2Flag && isError
  }

  private doMasterFieldDelete () {
    (async () => {
      this.showLoading = true
      const result = await MasterFieldDeleteApi.doMasterFieldDelete(this.$route.params.field_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '圃場を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/field').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.isValidate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    if (this.isEdit) {
      this.masterFieldEdit()
    } else {
      this.masterFieldCreate()
    }
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: string) {
    let before = String(this.fieldData[key1][key2])

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = parseFloat(tmp.split('').reverse().join(''))
    }

    if (isNaN(after)) {
      this.fieldData[key1][key2] = null
    } else {
      this.fieldData[key1][key2] = after
    }
    // 圃場面積(ha)を算出
    if (key2 === 'field_area_m2') {
      this.calculationArea()
    }
  }

  private calculationArea () {
    if (this.fieldData.field.field_area_m2 === null) {
      this.fieldData.field.field_area = null
    } else if (this.fieldData.field.field_area_m2 === 0) {
      this.fieldData.field.field_area = 0
    } else if (this.fieldData.field.field_area_m2 < 100) {
      this.fieldData.field.field_area = 0.01
    } else {
      const val = this.fieldData.field.field_area_m2 / 10000
      this.fieldData.field.field_area = Math.round(val * 100) / 100
    }
  }

  // 入力値に合わせて背景色・カラーピッカーの設定
  private colorSetting () {
    if (this.fieldData.field.color_code === '') {
      this.colors = '#FF3535'
    } else {
      this.colors = this.fieldData.field.color_code
    }
  }

  private closeColorPicker () {
    if (this.colors.hex === undefined) {
      this.fieldData.field.color_code = '#FF3535'
      this.colors = '#FF3535'
    } else {
      this.fieldData.field.color_code = this.colors.hex
      this.colors = this.colors.hex
    }
    this.showColorPicker = false
  }

  private doCancel () {
    this.$router.push('/master/field').catch(e => {})
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    if (num === null || num === undefined) {
      return ''
    } else {
      return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }
}
